import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchNhkMarcRegPageLoadResult,
  BatchNhkMarcRegPageLoadResultFromJSON
} from '@/api/models/batch/BatchNhkMarcRegPageLoadResult'
import {
  BatchNhkMarcRegRequest,
  BatchNhkMarcRegRequestToJSON
} from '@/api/models/batch/BatchNhkMarcRegRequest'

export class BatchNhkMarcRegApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchNhkMarcRegPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchNhkMarcRegPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createNhkMarcRegist(request: BatchNhkMarcRegRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/regist-nhk-marc`,
      BatchNhkMarcRegRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
